import { useContext } from 'react'

import { InputCreditCardContext } from '../contexts/input-credit-card-context'

export function useInputCreditCardProps() {
  const props = useContext(InputCreditCardContext)
  return props
}
